import moment from "moment-timezone";

export const MICROSECONDS_IN_A_SECOND = 1_000_000;
export const MICROSECONDS_IN_A_MINUTE = MICROSECONDS_IN_A_SECOND * 60;
export const MICROSECONDS_IN_AN_HOUR = MICROSECONDS_IN_A_MINUTE * 60;

export function hoursToMicros(hours: number) {
    return Math.floor(hours * MICROSECONDS_IN_AN_HOUR);
}

export function secondsToMicros(seconds: number) {
    return Math.floor(seconds * MICROSECONDS_IN_A_SECOND);
}

export function microsToMillis(micros: number) {
    return Math.floor(micros / 1000);
}

export function microsToMinutes(micros: number) {
    return Math.floor(micros / MICROSECONDS_IN_A_MINUTE);
}

export function microsToHours(micros: number) {
    return Math.floor(micros / MICROSECONDS_IN_AN_HOUR);
}

export function microsToHoursAndMinutes(ms: number) {
    const time = moment.utc(microsToMillis(ms));
    return {
        hours: time.hours(),
        minutes: time.minutes(),
    };
}
